import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';
import 'firebase/compat/storage';
import { getAuth } from 'firebase/auth';


const config = {
          apiKey: "AIzaSyDUcKQ7MGEdeuNrrRv1mmZWl-Ye6y2MdMY",
          authDomain: "sajids-design-studio-93b2c.firebaseapp.com",
          projectId: "sajids-design-studio-93b2c",
          storageBucket: "sajids-design-studio-93b2c.appspot.com",
          messagingSenderId: "330058031546",
          appId: "1:330058031546:web:16036ec76719d89a027d83"
}
if (!firebase.apps.length) {
    firebase.initializeApp(config)
}
const firestore = firebase.firestore()
const storage = firebase.storage()
const auth = getAuth(firebase.initializeApp(config))
export {firestore, storage, auth, firebase as default}